"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TwoColumnLayoutWithImage() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="twocolumnlayoutwithimage" className="bg-background !bg-[url(https://newmavericks.com/wp-content/uploads/2026/02/ceo-window.png)] bg-cover bg-center py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div ref={headingRef} className={`mb-12 transition-all duration-[var(--duration-medium)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="font-display font-bold text-foreground ![margin:-20px_0px_0px_0px] !text-4xl">  Client Results</h2>
        </div>

        <div ref={contentRef} className={`flex flex-col md:flex-row gap-12 items-center transition-all duration-[var(--duration-slow)] ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex-1">
            <p className="leading-relaxed text-foreground !text-xl">We've enabled over 100 leaders to evolve their leadership capacity and it has resulted in tens of billions in revenue &amp; stock value appreciation through these leaders getting major deals with the likes of:<div><br /></div><div><i><b>Hyundai-Kia, Siemens, General Electric, FedX, IMG, McDonalds, Chemist Warehouse, Life Health Care, Portfolio Partners, Harcourts, Top govt contractors, Governments, English Premiership League, SANZAAR Rugby, Top US College Sporting Conferences, IGV - Top China eSports company, and Cricket Australia.</b></i></div><div><br /></div><div>Approaches in our program have been scientifically validated by over 600 studies for developing leaders highest potential, performance &amp; health.</div><div><br /></div><div>We do what is right for the leaders &amp; companies we serve!</div></p>
          </div>
          <div className="flex-1 w-full">
            <img src="https://newmavericks.com/wp-content/uploads/2026/02/Clients-clients.png" alt="Client Results Visualization" className="w-full h-auto rounded-lg shadow-medium" />
          </div>
        </div>
      </div>
    </section>;
}